import Consultant from "../models/Consultant";
import NewSessionId from "../common/SessionGenerator";
import {plainToInstance} from 'class-transformer'


const GetConsultants = (site: string, key: string): Promise<Consultant[]> => {
    return fetch(`/data/listing/${site}/${key}/${NewSessionId()}`)
        .then(response => response
            .json()
            .then(data => data.consultants
                .map((result: any) => plainToInstance(Consultant, result.consultant))
            )
        );
}

export default GetConsultants;